export const alreadyConnectedToChatNotification = { message: 'You are already connected to chat.' };
export const alreadyDisconnectedToChatNotification = { message: 'You are already disconnected to chat.' };
export const noCleavageAvailableNotification = { message: 'There is no cleavage available.' };
